import { VisualizatorSettings } from "../../visualizator-settings";
import { ObjectCreator } from "../../../../../../../web-graphics";

export class MarkPlotSettings extends VisualizatorSettings {
  constructor(settings) {
    super();

    const simpleFields = [
      "id_mark",
      "type",
      "place",
      "x_axis",
      "y_axis",
      "min_x_space",
      "min_y_space"
    ];
    for (const key of Object.getOwnPropertyNames(settings)) {
      if (simpleFields.includes(key)) {
        this[key] = settings[key];
      } else if (key == "color") {
        this.color = []; // type: array of float
        for (let i = 0; i < settings.color.length; i++) {
          this.color.push(settings.color[i]);
        }
      } else {
        if (typeof settings[key] === "object" && settings[key].copy !== undefined) {
          this[key] = settings[key].copy();
        } else if (typeof settings[key] !== "function") {
          this[key] = ObjectCreator.deepCopy(settings[key]);
        }
      }
    }
  }

  copy() {
    return new MarkPlotSettings(this);
  }
}
